const STORAGE_KEY = 'adminPortalAuthNotice'

/**
 * Persist a one-shot notice for the login page (survives full redirect).
 * @param {string} [serverDetail] - optional message from API (truncated)
 */
export function setAdminPortalAuthNotice(serverDetail) {
  try {
    const detail =
      serverDetail && String(serverDetail).trim().slice(0, 500) || ''
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ detail, at: Date.now() }),
    )
  } catch {
    /* ignore quota / private mode */
  }
}

/** Read and remove notice so it does not repeat on refresh. */
export function consumeAdminPortalAuthNotice() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    sessionStorage.removeItem(STORAGE_KEY)
    return JSON.parse(raw)
  } catch {
    return null
  }
}
